import React from 'react';
import { Grid } from 'semantic-ui-react';
import fields, { fieldLengths } from '@/constants/fields';
import DatasourceInputField from './DatasourceInputField';

const DatasourceCompactDatabaseFields = ({ disabled, settings, updateSettings }) => (
  <>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="host"
        field={fields.HOST}
        onChange={(value) => updateSettings({ host: value })}
        saveErrors={settings.saveErrors}
        text={settings.host}
      />
    </Grid.Row>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="name"
        field={fields.NAME}
        onChange={(value) => updateSettings({ name: value })}
        saveErrors={settings.saveErrors}
        text={settings.name}
      />
    </Grid.Row>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="username"
        field={fields.USERNAME}
        onChange={(value) => updateSettings({ username: value })}
        saveErrors={settings.saveErrors}
        text={settings.username}
      />
    </Grid.Row>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="password"
        field={fields.PASSWORD}
        maxLength={fieldLengths.large}
        onChange={(value) => updateSettings({ password: value })}
        saveErrors={settings.saveErrors}
        text={settings.password}
        type="password"
      />
    </Grid.Row>
  </>
);

export default DatasourceCompactDatabaseFields;
